import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function PricingSection() {
  const {
    t
  } = useLanguage();
  const exhibitions = [{
    no: '1',
    name: 'CMEF 2026',
    address: 'No. 333 Songze Avenue, Qingpu District, Shanghai, China',
    time: '4.09-4.12',
    booth: '6.2K04'
  }, {
    no: '2',
    name: 'MEVOS 2026',
    address: 'PHangzhou International Expo Center, Hangzhou, Zhejiang, China',
    time: '4.10-4.12',
    booth: 'VIP 8'
  }, {
    no: '3',
    name: '139th Canton Fair',
    address: 'No. 382, Yuejiang Zhong Road, Haizhu District, Guangzhou, China',
    time: '5.01-5.05',
    booth: '9.2L 13-14'
  }, {
    no: '4',
    name: 'Hospitalar 2026',
    address: 'Rodovia dos Imigrantes, KM 1,5 - Vila Água Funda, São Paulo - SP, 04329-900, Brazil',
    time: '5.19-5.22',
    booth: 'D-138'
  }, {
    no: '5',
    name: 'WHX Miami 2026',
    address: 'D1901 Convention Ctr Dr, Miami Beach, FL 33139, United States',
    time: '6.17-6.19',
    booth: 'F44'
  }, {
    no: '6',
    name: 'Dubai Derma 2026',
    address: 'Sheikh Zayed Road, Dubai, United Arab Emirates',
    time: '6.29-7.02',
    booth: '1F01'
  }];
  return <section id="exhibitions" className="py-24 bg-brand-bg" data-id="element-386">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-387">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-388">
          <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-389">
            {t('exhibitions.label')}
          </h2>
          <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" data-id="element-390">
            {t('exhibitions.title1')}{' '}
            <span className="font-semibold" data-id="element-391">{t('exhibitions.title2')}</span>
          </h3>
          <p className="text-gray-600" data-id="element-392">{t('exhibitions.subtitle')}</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-brand-lightCopper overflow-hidden" data-id="element-393">
          <div className="overflow-x-auto" data-id="element-394">
            <table className="w-full text-left border-collapse" data-id="element-395">
              <thead data-id="element-396">
                <tr className="bg-brand-lightCopper/30 text-gray-900" data-id="element-397">
                  <th className="py-4 px-6 font-semibold border-b border-brand-lightCopper/50 text-center w-16" data-id="element-398">
                    {t('exhibitions.no')}
                  </th>
                  <th className="py-4 px-6 font-semibold border-b border-brand-lightCopper/50" data-id="element-399">
                    {t('exhibitions.exhibition')}
                  </th>
                  <th className="py-4 px-6 font-semibold border-b border-brand-lightCopper/50" data-id="element-400">
                    {t('exhibitions.address')}
                  </th>
                  <th className="py-4 px-6 font-semibold border-b border-brand-lightCopper/50 text-center" data-id="element-401">
                    {t('exhibitions.time')}
                  </th>
                  <th className="py-4 px-6 font-semibold border-b border-brand-lightCopper/50 text-center" data-id="element-402">
                    {t('exhibitions.booth')}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-403">
                {exhibitions.map((exhibition, index) => <tr key={index} className="hover:bg-gray-50 transition-colors" data-id="element-404">
                    <td className="py-4 px-6 text-center font-medium text-gray-900" data-id="element-405">
                      {exhibition.no}
                    </td>
                    <td className="py-4 px-6 font-medium text-gray-900" data-id="element-406">
                      {exhibition.name}
                    </td>
                    <td className="py-4 px-6 text-gray-600 text-sm leading-relaxed" data-id="element-407">
                      {exhibition.address}
                    </td>
                    <td className="py-4 px-6 text-center text-gray-600 whitespace-nowrap" data-id="element-408">
                      {exhibition.time}
                    </td>
                    <td className="py-4 px-6 text-center font-medium text-gray-900 whitespace-nowrap" data-id="element-409">
                      {exhibition.booth}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}